import React from 'react';
import { StyledBasicTextWithUIGuidelines } from './styles';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { ICustomTheme } from 'interfaces';

type TProps = {
  text: string;
  color?: string;
  fontWeight?: string | number;
  margin?: string;
};

export const BasicTextWithUIGuidelines = ({
  text,
  margin,
  color,
  fontWeight,
}: TProps) => {
  const theme: ICustomTheme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });

  return (
    <StyledBasicTextWithUIGuidelines
      isMobile={isMobile}
      margin={margin}
      color={color}
      fontWeight={fontWeight}
    >
      {text}
    </StyledBasicTextWithUIGuidelines>
  );
};
